import { render, staticRenderFns } from "./DcsView.vue?vue&type=template&id=4fcbd340&scoped=true"
import script from "./DcsView.vue?vue&type=script&lang=ts"
export * from "./DcsView.vue?vue&type=script&lang=ts"
import style0 from "./DcsView.vue?vue&type=style&index=0&id=4fcbd340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbd340",
  null
  
)

export default component.exports